import { render } from "./KatmanlarMenu.vue?vue&type=template&id=4ccc434c"
import script from "./KatmanlarMenu.vue?vue&type=script&lang=js"
export * from "./KatmanlarMenu.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__